module.exports = __webpack_public_path__ + "static/media/balance_100000_250000.ee823c38.png";